<p>Angular-test-tio-angular works</p>
@if (usuario() != null) {
  <div class="container">
    <h2>Detalles del Usuario con resolver e input</h2>
    <p><strong>ID:</strong> {{ usuario().usuario_id }}</p>
    <p><strong>Nombre:</strong> {{ usuario().nombre }}</p>
    <p><strong>Apellidos:</strong> {{ usuario().apellidos }}</p>
    <p><strong>Dirección:</strong> {{ usuario().direccion }}</p>
   
  </div>
} @else {
  <p>No hay datos de usuario disponibles de usuario con resolver e input</p>
}
@if (usuarioResolverComputed() != null) {
  <div class="container">
    <h2>Detalles del Usuario con resolver y computed</h2>
    <p><strong>ID:</strong> {{ usuarioResolverComputed().usuario_id }}</p>
    <p><strong>Nombre:</strong> {{ usuarioResolverComputed().nombre }}</p>
    <p><strong>Apellidos:</strong> {{ usuarioResolverComputed().apellidos }}</p>
    <p><strong>Dirección:</strong> {{ usuarioResolverComputed().direccion }}</p>
    
  </div>
} @else {
  <p>No hay datos de usuario disponibles de usuario con resolved</p>
}
@if (usuarioSignal() != null) {
  <div class="container">
    <h2>Detalles del Usuario con signal</h2>
    <p><strong>ID:</strong> {{ usuarioSignal().usuario_id }}</p>
    <p><strong>Nombre:</strong> {{ usuarioSignal().nombre }}</p>
    <p><strong>Apellidos:</strong> {{ usuarioSignal().apellidos }}</p>
    <p><strong>Dirección:</strong> {{ usuarioSignal().direccion }}</p>
   
  </div>
} @else {
  <p>No hay datos de usuario disponibles de usuario con signal</p>
}
<p><strong>Usuario resolver input{{ usuario() | json }} </strong></p>
<p><strong>Usuario resolver computed{{ usuarioResolverComputed() | json }} </strong></p>
<p><strong>Usuario signal{{ usuarioSignal() | json }} </strong></p>

